/**
 * HTML ID attribute for the permissions dialog. Is used to teleport
 * dropdowns into the dialog so we don't close the dialog when clicking
 * dropdowns.
 */
export const PERMISSIONS_DIALOG_ID = 'permissions-dialog'
